export default __webpack_public_path__ + "static/media/dripsSlide2.38ad6ef3.png";